import * as React from 'react';
import { SharedState } from 'app/types-shared';
import { PromptConfirmationModal } from 'ui';
import { urlToExcel, caseViewTemplate, actionViewTemplate } from './url-to-excel';

interface ExcelLinksProps {
  favouriteId?: number;
  sharedState: SharedState;
  translation: any;
}
class ExcelLink extends React.PureComponent<{ favouriteId: number; label: string; template: string; translation: any }, {}> {

  private handleExcel = () => {

    const { favouriteId, template } = this.props;
    window.location.assign(urlToExcel(favouriteId, template));
  };

  public render() {

    const { translation, label } = this.props;

    return (<PromptConfirmationModal
      title={translation.excel_modal_title}
      description={translation.excel_modal_description}
      continueText={translation.excel_modal_ok_button}
      cancelText={translation.excel_modal_cancel_button}
      onContinue={this.handleExcel}>
      <li><button type="button" className="dropdown-item">{label}</button></li>
    </PromptConfirmationModal>);
  }
}

export const ExcelLinks = (props: ExcelLinksProps) => {

  return !!props.favouriteId && !!props.sharedState.access && !!props.sharedState.access.tools.excelAddIn && <>
    <ExcelLink label={props.translation.excel_edit_cases}
      template={caseViewTemplate}
      favouriteId={props.favouriteId}
      translation={props.translation} />
    <ExcelLink label={props.translation.excel_edit_cases_with_actions}
      template={actionViewTemplate}
      favouriteId={props.favouriteId}
      translation={props.translation} />
  </>;
};
